// src/pages/OrdersManagement.jsx
import { useState } from "react";
import { useLoaderData } from "react-router-dom";
import exportToCSV from "../components/exportToCSV";

export async function loader() {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Response(
      JSON.stringify({
        message: "You must be logged in to access this resource.",
      }),
      { status: 401 }
    );
  }

  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/ct/orders`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-App-Secret": process.env.REACT_APP_APP_SECRET,
      },
    }
  );

  if (!response.ok) {
    throw new Response(JSON.stringify({ message: "Could not fetch orders." }), {
      status: response.status,
    });
  }

  const orders = await response.json();
  return orders;
}

export default function OrdersManagement() {
  const orders = useLoaderData();
  const [filters, setFilters] = useState({
    order_number: "",
    customer_email: "",
    payment_status: "",
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Filter orders based on active filters.
  const filteredOrders = orders.filter((order) =>
    Object.entries(filters).every(([key, value]) => {
      if (!value) return true;
      return String(order[key]).toLowerCase().includes(value.toLowerCase());
    })
  );

  return (
    <div className="orders-management-container">
      <h1>Orders Management</h1>
      <div className="filters">
        <label>
          Order Number:
          <input
            type="text"
            name="order_number"
            value={filters.order_number}
            onChange={handleFilterChange}
          />
        </label>
        <label>
          Customer Email:
          <input
            type="text"
            name="customer_email"
            value={filters.customer_email}
            onChange={handleFilterChange}
          />
        </label>
        <label>
          Payment Status:
          <input
            type="text"
            name="payment_status"
            value={filters.payment_status}
            onChange={handleFilterChange}
          />
        </label>
      </div>
      <div className="export-button">
        <button
          onClick={() => exportToCSV(filteredOrders, "orders.csv")}
          className="export-btn"
        >
          Export CSV
        </button>
      </div>
      <table className="management-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Order Number</th>
            <th>Stripe Payment ID</th>
            <th>Customer Email</th>
            <th>Payment Status</th>
            <th>Total Amount</th>
            <th>Currency</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th>Order Details</th>
            <th>Shipping Details</th>
          </tr>
        </thead>
        <tbody>
          {filteredOrders.map((order) => (
            <tr key={order.id}>
              <td>{order.id}</td>
              <td>{order.order_number}</td>
              <td>{order.stripe_payment_intent}</td>
              <td>{order.customer_email}</td>
              <td>{order.payment_status}</td>
              <td>£{order.total_amount}</td>
              <td>{order.currency}</td>
              <td>{new Date(order.created_at).toLocaleString()}</td>
              <td>{new Date(order.updated_at).toLocaleString()}</td>
              {/* Order Details Column */}
              <td>
                <ul style={{ margin: 0, paddingLeft: "16px" }}>
                  {(() => {
                    try {
                      const items =
                        typeof order.order_details === "string"
                          ? JSON.parse(
                              order.order_details
                                .replace(/""/g, '"')
                                .replace(/(^"|"$)/g, "")
                            )
                          : order.order_details;

                      return items.map((i, idx) => (
                        <li key={idx}>
                          {i.name}({i.product_id}) – Size {i.size} – Qty{" "}
                          {i.quantity}
                        </li>
                      ));
                    } catch (err) {
                      return <li style={{ color: "red" }}>Invalid data</li>;
                    }
                  })()}
                </ul>
              </td>

              {/* Shipping Details Column */}
              <td>
                {(() => {
                  try {
                    const s =
                      typeof order.shipping_details === "string"
                        ? JSON.parse(
                            order.shipping_details
                              .replace(/""/g, '"')
                              .replace(/(^"|"$)/g, "")
                          )
                        : order.shipping_details;

                    return (
                      <address style={{ whiteSpace: "pre-line" }}>
                        {s.name && `${s.name}\n`}
                        {s.line1 && `${s.line1}\n`}
                        {s.line2 && `${s.line2}\n`}
                        {s.city && `${s.city}\n`}
                        {s.postal_code && `${s.postal_code}\n`}
                        {s.country && `${s.country}`}
                      </address>
                    );
                  } catch (err) {
                    return (
                      <span style={{ color: "red" }}>Invalid address data</span>
                    );
                  }
                })()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
